/**
 * Feriados nacionais do Brasil, calculados no front (sem tabela nem endpoint).
 * Fixos pela data e móveis pela Páscoa (Carnaval, Sexta-feira Santa, Páscoa e
 * Corpus Christi, que o país inteiro observa mesmo onde são ponto facultativo).
 * Só aviso na agenda: nada aqui bloqueia horário.
 * Feriados estaduais e municipais ficam para um cadastro por conta (fase 2).
 */

const FIXED = {
  '01-01': 'Confraternização Universal',
  '04-21': 'Tiradentes',
  '05-01': 'Dia do Trabalho',
  '09-07': 'Independência do Brasil',
  '10-12': 'Nossa Senhora Aparecida',
  '11-02': 'Finados',
  '11-15': 'Proclamação da República',
  '11-20': 'Dia da Consciência Negra',
  '12-25': 'Natal',
};

const pad = (n) => String(n).padStart(2, '0');
const keyOf = (date) => `${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

const shift = (date, days) => {
  const d = new Date(date);
  d.setDate(d.getDate() + days);
  return d;
};

/** Domingo de Páscoa do ano (algoritmo de Meeus/Jones/Butcher, calendário gregoriano). */
export const easterSunday = (year) => {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  const day = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(year, month - 1, day);
};

const movableCache = new Map();

/** Feriados móveis do ano: { 'MM-DD': nome }. */
const movableOf = (year) => {
  if (!movableCache.has(year)) {
    const easter = easterSunday(year);
    movableCache.set(year, {
      [keyOf(shift(easter, -48))]: 'Carnaval',
      [keyOf(shift(easter, -47))]: 'Carnaval',
      [keyOf(shift(easter, -2))]: 'Sexta-feira Santa',
      [keyOf(easter)]: 'Páscoa',
      [keyOf(shift(easter, 60))]: 'Corpus Christi',
    });
  }
  return movableCache.get(year);
};

/** Nome do feriado nacional na data, ou null quando é dia comum. */
export const getNationalHoliday = (date) => {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return null;
  const key = keyOf(date);
  return FIXED[key] || movableOf(date.getFullYear())[key] || null;
};
